module.exports = __webpack_public_path__ + "static/images/saved-poi-work-icon.2tA0npK.svg";